import type { AxiosResponse } from 'axios';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type { IOperator } from './types';

export const getAll = ()
  : Promise<void | AxiosResponse<IOperator []>> => axiosInstance({
  url: `${ROUTES.OPERATORS}`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});
